import React, { Component } from "react";
import { translate } from "../Services/translation";
import { get, post, put } from "../Services/http";

class ShowVat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      includeVAT: '',
      isVisible: false
    };
    this.setVat = this.setVat.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    get("/api/utility/includevat")
      .then(response => response.json())
      .then(({includeVAT}) => this.setState({ includeVAT }));
  }

  setVat() {
    return post("/api/utility/includevat", {
      includeVAT: !this.state.includeVAT
    })
      .then(response => response.json())
      .then(({includeVAT}) => {
        this.setState({ includeVAT })
        window.location.reload()
      })
      .catch(ex => dispatch(catchError(ex, error => loadError(error))));
  }

  toggle() {
    this.setState({ isVisible: !this.state.isVisible });
  }

  render() {
    return (
      <div className="header__show-vat">
        <a className="header__top-link" onClick={this.toggle}>
        {this.state.includeVAT? translate("includevat") : translate("excludevat")}
          <i className="icon ion-md-arrow-dropdown header__show-vat__icon" />
        </a>

        <div className={"header__show-vat__dropdown " + (this.state.isVisible? '' : 'hidden')}>
          <ul>
            <li>
              <input
                type="radio"
                name="radio"
                id="include"
                onChange={this.setVat}
                checked={this.state.includeVAT}
                value={this.state.includeVAT}
              />{" "}
              {translate("includevat")}
            </li>
            <li>
              <input
                type="radio"
                name="radio"
                id="exclude"
                onChange={this.setVat}
                checked={!this.state.includeVAT}
                value={!this.state.includeVAT}
              />{" "}
              {translate("excludevat")}
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default ShowVat;
